import { Button } from '@pets-ui/Button/Button'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { useContextLogin } from './useContextLogin'

const styles = stylex.create({
  root: {
    marginTop: '12px',
  },
})

interface ButtonLoginProps {
  title?: string
}

export function ButtonLogin({ title }: ButtonLoginProps) {
  const { validatePhone, phone } = useContextLogin()
  const { t } = useTranslation()

  return (
    <Button
      variant="filled"
      fullWidth
      onClick={validatePhone}
      disabled={phone.trim() === ''}
      rootStyle={styles.root}
    >
      {title ?? t('login.loginOrRegister')}
    </Button>
  )
}
